import React from 'react';
import t from '@guestyci/localize/t.macro';
import { Button, Stack } from '@guestyci/arc';

const StepActions = ({
  primaryLabel = t('Next'),
  primaryType = 'button',
  primaryDisabled = false,
  onPrimaryClick,
  onSecondaryClick,
  secondaryLabel = t('Pick a different authentication method'),
  isSubmitting,
}) => (
  <Stack spacing={2} className="gst-w-full">
    <Button
      type={primaryType}
      className="gst-w-full"
      onClick={onPrimaryClick}
      disabled={primaryDisabled || isSubmitting}
      isLoading={isSubmitting}
    >
      {primaryLabel}
    </Button>
    <Button
      type="button"
      variant="plain"
      className="gst-w-full"
      onClick={onSecondaryClick}
      disabled={isSubmitting}
    >
      {secondaryLabel}
    </Button>
  </Stack>
);

export default StepActions;
